/**
 * 内部触发jsbridge的方式，作为一个工具类提供
 */
export default function generateJSBridgeTrigger(JSBridge) {
  /**
   * 有三大类型，短期回调，延时回调，长期回调?，其中长期回调中又有一个event比较特殊
   * @param {JSON} options 配置参数，包括
   * handlerName 方法名
   * data 额外参数
   * isLongCb 是否是长期回调，如果是，则会生成一个长期回调id，以长期回调的形式存在
   * proto 对应方法的模块名
   * 其它 代表相应的头部
   * @param {Function} resolve promise中成功回调函数
   * @param {Function} reject promise中失败回调函数
   */
  return function callJSBridge(options, resolve, reject) {
    var success = options.success,
        error = options.error,
        dataFilter = options.dataFilter,
        handlerName = options.handlerName,
        moduleName = options.moduleName,
        isLongCb = options.isLongCb,
        isEvent = options.isEvent,
        data = options.data;

    var cbFunc = function cbFunc(res) {
      if (+res.error_code !== 0) {
        error && error(res);
        !isLongCb && reject && reject(res);
      } else {
        var finalRes = res;

        if (dataFilter) {
          finalRes = dataFilter(finalRes);
        }

        success && success(finalRes.data);
        !isLongCb && resolve && resolve(finalRes.data);
      }
    };

    if (isLongCb) {
      /**
       * 长期回调的做法，需要注册一个长期回调id,每一个方法都有一个固定的长期回调id
       * 短期回调的做法(短期回调执行一次后会自动销毁)
       * 但长期回调不会销毁，因此可以持续触发，例如下拉刷新
       * 长期回调id通过函数自动生成，每次会获取一个唯一的id
       */
      var longCallbackId = JSBridge.getLongCallBackId();

      if (isEvent) {
        data.port = longCallbackId;
      }

      JSBridge.registerLongCallback(longCallbackId, cbFunc);
      JSBridge.callHandler(moduleName, handlerName, data, longCallbackId);
      resolve && resolve();
    } else {
      JSBridge.callHandler(moduleName, handlerName, data, cbFunc);
    }
  };
}